import React from "react";
import portrait from "../Assets/MaxCutout.png";
import ExternalLink from "./ExternalLink";
import { profiles, resumeFile, summary } from "../content";

function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="shell hero-layout">
        <div className="hero-intro">
          <p className="eyebrow">Battery management systems</p>
          <h1 id="hero-title">
            Max <span className="hero-surname">Kotas</span>
          </h1>
          <p className="lede">{summary.lead}</p>
          <p className="lede-quiet">{summary.support}</p>
          <p className="location">McKinney, TX · Open to Austin</p>
          <ul className="link-row">
            <li>
              <a href={profiles.email}>Email</a>
            </li>
            <li>
              <ExternalLink href={profiles.linkedin}>LinkedIn</ExternalLink>
            </li>
            <li>
              <ExternalLink href={profiles.github}>GitHub</ExternalLink>
            </li>
            <li>
              <ExternalLink href={resumeFile}>Resume PDF</ExternalLink>
            </li>
          </ul>
        </div>
        <figure className="hero-portrait">
          <img src={portrait} alt="Max Kotas" width="1460" height="2678" />
        </figure>
      </div>
    </section>
  );
}

export default Hero;
